<h2 mat-dialog-title>{{title}}'</h2>
@if (busy) {
  <div class="overlay">
    <div class="center">
      <mat-spinner>
      </mat-spinner>
    </div>
  </div>
}
<mat-dialog-content>
  <app-representations-table [buyerRepresentations]="buyerRepresentations"></app-representations-table>
</mat-dialog-content>
<mat-dialog-actions >
  <div class="flex-row spce-between items-center w-100 mt-3 p-2">
    <button mat-flat-button class="w-100" color="primary" (click)="onConfirmClick()" tabindex="1" >{{confirmButtonText}}</button>
  </div>
</mat-dialog-actions>

